import React, { useEffect, useState } from 'react';
import { useLoader } from '../context/LoaderContext';
import { useParams } from 'react-router-dom';
import { ICooperativeDetails } from '../exports/interfaces';
import { useUser } from '../context/UserContext';
import { fetchCooperativeDetails } from '../api/Cooperative';
import { dynamicFailed } from '../hooks/useToast';
import PageLayout from '../components/PageLayout';
import SearchHeader from '../components/SearchHeader';
import RegisterEdit from '../components/register/RegisterEdit';

const EditRegisterPage = () => {
  const { setLoading } = useLoader();
  const { id } = useParams();
  const [cooperative, setCooperative] = useState<ICooperativeDetails | null>(null);
  const { user } = useUser();

  useEffect(() => {
    setLoading(true);
    if (!user) {
      return;
    }

    Promise.all([fetchCooperativeDetails(Number(id))])
      .then(([cooperativeData]) => {
        setCooperative(cooperativeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [id, setLoading, user]);

  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <RegisterEdit cooperative={cooperative} />
      </div>
    </PageLayout>
  );
};

export default EditRegisterPage;


// Cooperative Data:-
// {id: 17, registrationNumber: 'Reg 100', businessregistrationNumber: '79846554', nameNepali: 'test', nameEnglish: 'test', …}
// address
// : 
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// district
// : 
// "Kathmandu"
// id
// : 
// 17
// municipality
// : 
// "Kathmandu Metropolitan City"
// province
// : 
// "Bagmati"
// streetTole
// : 
// "test"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// ward
// : 
// 8
// [[Prototype]]
// : 
// Object
// businessregistrationNumber
// : 
// "79846554"
// contactPerson
// : 
// "test"
// cooperativeandexecutive
// : 
// committeemember
// : 
// bodDocumentUrl
// : 
// "uploads\\1782127012874-881961706.png"
// citizenship
// : 
// "48954652132"
// committeeType
// : 
// "Board Committee"
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// district
// : 
// "Kathmandu"
// education
// : 
// "Bachelors"
// email
// : 
// "test@gmail.com"
// fatherName
// : 
// "test"
// fullName
// : 
// "test"
// grandmotherName
// : 
// "test"
// husbandName
// : 
// "test"
// id
// : 
// 17
// issuedDistrict
// : 
// "Kathmandu"
// municipality
// : 
// "Kathmandu Metropolitan City"
// nid
// : 
// "546651"
// pan
// : 
// "5651651"
// photoUrl
// : 
// "uploads\\1782127012873-370329256.png"
// position
// : 
// "Chairperson"
// positionStatus
// : 
// "Active"
// province
// : 
// "Bagmati"
// street
// : 
// "test"
// tenureEnd
// : 
// "2026-06-15"
// tenureStart
// : 
// "2026-06-14"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// ward
// : 
// 4
// [[Prototype]]
// : 
// Object
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// executivemember
// : 
// address
// : 
// "test"
// citizenship
// : 
// "9875432102"
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// currentPositionDuration
// : 
// 2
// district
// : 
// "Kathmandu"
// education
// : 
// "Bachelors"
// email
// : 
// "test@gmail.com"
// experience
// : 
// 2
// fatherName
// : 
// "test"
// fullName
// : 
// "test"
// gender
// : 
// "Male"
// grandmotherName
// : 
// "test"
// husbandName
// : 
// "test"
// id
// : 
// 17
// issuedDistrict
// : 
// "Kathmandu"
// mobile
// : 
// "9874563210"
// municipality
// : 
// "Kathmandu Metropolitan City"
// nid
// : 
// "21651321"
// pan
// : 
// "5132251321"
// photoUrl
// : 
// "uploads\\1782127012883-763488470.png"
// position
// : 
// "CEO"
// positionStatus
// : 
// "Active"
// province
// : 
// "Bagmati"
// street
// : 
// "test"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// ward
// : 
// 4
// [[Prototype]]
// : 
// Object
// id
// : 
// 17
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// declaration
// : 
// null
// documents
// : 
// agmDocumentUrl
// : 
// null
// businessRegistrationUrl
// : 
// null
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// foundingDocumentUrl
// : 
// null
// id
// : 
// 17
// lawDocumentUrl
// : 
// null
// meetingDocumentUrl
// : 
// null
// otherDocumentUrl
// : 
// null
// panDocumentUrl
// : 
// null
// regCertificateUrl
// : 
// null
// taxClearanceUrl
// : 
// null
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// email
// : 
// "test@gmail.com"
// femaleMembers
// : 
// 2
// financial
// : 
// audit
// : 
// agmDate
// : 
// "2026-06-14"
// auditorAddress
// : 
// "test"
// auditorMobile
// : 
// "9874563210"
// auditorName
// : 
// "test"
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// documentUrl
// : 
// "uploads\\1782127012869-728402800.png"
// fiscalYear
// : 
// "2081/82"
// icanNumber
// : 
// "9874563210"
// id
// : 
// 17
// participants
// : 
// 2
// participantsPercent
// : 
// "2.00"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// id
// : 
// 17
// income
// : 
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// fiscalYear
// : 
// "2080/81"
// id
// : 
// 17
// netProfitLoss
// : 
// "2.00"
// operationalExpenses
// : 
// "2.00"
// operationalIncome
// : 
// "2.00"
// otherExpenses
// : 
// "2.00"
// otherIncome
// : 
// "2.00"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// loan
// : 
// accumulatedProfitLoss
// : 
// "2.00"
// additionalProvisionLoanLoss
// : 
// "2.00"
// assetsRevaluationReserve
// : 
// "2.00"
// coreCapital
// : 
// "2.00"
// coreCapitalRatio
// : 
// "2.00"
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// deficitReplenishmentFund
// : 
// "2.00"
// externalLoan
// : 
// "2.00"
// femaleBorrowers
// : 
// "2.00"
// fiscalYear
// : 
// "2081/82"
// freeReserve
// : 
// "2.00"
// id
// : 
// 17
// investmentHouseBuilding
// : 
// "2.00"
// investmentPrivateLtd
// : 
// "2.00"
// llpDoubtfulLoan
// : 
// "2.00"
// llpLossLoan
// : 
// "2.00"
// llpPassLoan
// : 
// "2.00"
// llpSubStandardLoan
// : 
// "2.00"
// loanRescheduledAmount
// : 
// "2.00"
// loanRescheduledCount
// : 
// 2
// maleBorrowers
// : 
// "2.00"
// nplPercentage
// : 
// "2.00"
// othersBorrowers
// : 
// "2.00"
// supplementaryCapital
// : 
// "-5.00"
// totalBorrowers
// : 
// 200
// totalBorrowing
// : 
// "2.00"
// totalCapitalFund
// : 
// "2.00"
// totalCapitalFundRatio
// : 
// "2.00"
// totalDoubtfulLoan
// : 
// "2.00"
// totalLoanDisbursed
// : 
// "2.00"
// totalLoanLossProvision
// : 
// "2.00"
// totalLossLoan
// : 
// "2.00"
// totalNonPerformingLoan
// : 
// "2.00"
// totalPassLoan
// : 
// "2.00"
// totalReserveFund
// : 
// "2.00"
// totalRiskWeightedAssets
// : 
// "2.00"
// totalShareCapital
// : 
// "2.00"
// totalSubStandardLoan
// : 
// "2.00"
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// share
// : 
// association
// : 
// "test"
// balanceSheet
// : 
// 200
// bank
// : 
// "test"
// cash
// : 
// "2.00"
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// districtUnion
// : 
// "test"
// femaleDepositors
// : 
// "2.00"
// femaleMembers
// : 
// 2
// fiscalYear
// : 
// "2081/82"
// id
// : 
// 17
// institutionalMembers
// : 
// 2
// maleDepositors
// : 
// "2.00"
// maleMembers
// : 
// 2
// otherDepositors
// : 
// "2.00"
// otherMembers
// : 
// 2
// tlaToTaRatio
// : 
// "2.00"
// totalAssets
// : 
// "2.00"
// totalDepositors
// : 
// 2
// totalGeneralSaving
// : 
// "2.00"
// totalLiabilities
// : 
// "2.00"
// totalLiquidAssets
// : 
// "2.00"
// totalPeriodicSaving
// : 
// "2.00"
// totalRegularSaving
// : 
// "2.00"
// totalSavingAmount
// : 
// "2.00"
// totalShareMembers
// : 
// 2
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// tax
// : 
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// employeeTax
// : 
// 2
// fiscalYear
// : 
// "2081/82"
// id
// : 
// 1
// incomeTax
// : 
// 2
// interestTax
// : 
// 2
// localOthers
// : 
// 2
// rentalTax
// : 
// 2
// serviceTax
// : 
// 2
// taxOthers
// : 
// 2
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// id
// : 
// 17
// isRegisteredInFederation
// : 
// false
// maleMembers
// : 
// 2
// mobileNumber
// : 
// "9874563210"
// nameEnglish
// : 
// "test"
// nameNepali
// : 
// "test"
// natureOfWork
// : 
// "Multipurpose"
// otherMembers
// : 
// 2
// panNumber
// : 
// "8975423165"
// registeredAt
// : 
// "Federal"
// registeredDate
// : 
// "2026-06-14"
// registeredEnglishDate
// : 
// "2026-06-21"
// registeredOfficeAddress
// : 
// "test"
// registrationNumber
// : 
// "Reg 100"
// shareMember
// : 
// createdAt
// : 
// "2026-06-22T11:16:53.000Z"
// id
// : 
// 17
// loanFemaleMembers
// : 
// 2
// loanMaleMembers
// : 
// 2
// loanMemberUrl
// : 
// "uploads\\1782127012885-190995206.png"
// loanOthersMembers
// : 
// 2
// loanTotalMembers
// : 
// 2
// savingFemaleMembers
// : 
// 2
// savingMaleMembers
// : 
// 2
// savingMemberUrl
// : 
// "uploads\\1782127012885-461767567.png"
// savingOthersMembers
// : 
// 2
// savingTotalMembers
// : 
// 2
// shareFemaleMembers
// : 
// 2
// shareMaleMembers
// : 
// 2
// shareMemberUrl
// : 
// "uploads\\1782127012884-687210149.png"
// shareOthersMembers
// : 
// 2
// shareTotalMembers
// : 
// 2
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// [[Prototype]]
// : 
// Object
// softwareUsed
// : 
// "test"
// staffCount
// : 
// 2
// updatedAt
// : 
// "2026-06-22T11:16:53.000Z"
// workingArea
// : 
// "Ward 1"
